import axios from "axios";
import { useFormik } from "formik";
import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import * as Yub from "yup";
import BaseURL from "../Utilities/BaseUrl";
import notify from "../Utilities/Notify";
import {cartContext} from '../Contexts/CartContext';
import { Helmet } from "react-helmet";
export default function Login({getToken}) {
  
  const [loading, setloading] = useState(true);
  const [disab, setdisab] = useState(true);
  let navigate = useNavigate();
  let {getCart}=useContext(cartContext);
  function tranferPass() {
    let ey1 = document.querySelector(".eye1");
    let inp1 = document.querySelector("#password");
    ey1.innerHTML = `<i class="fa-solid fa-eye eyeicon fa-xl cursor-pointer"></i>`;
    inp1.setAttribute("type", Text);
  }
  let Formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },

    onSubmit: (values) => {
      setloading(false);
      setdisab(false);
      axios
        .post(`${BaseURL}auth/signin`, values
        
        )
        .then((data) => {
          if (data.status == 200) {
            
           localStorage.setItem('token',data.data.token);
           localStorage.setItem('userName',data.data.user.name);
            notify('success',data.data.message);
              
              navigate("/home");
              getToken();
              getCart();
          }
         
        })
        .catch((error) => {
          if (error.response.status == 401)
          {
           notify('error',error.response.data.message);
           
             setloading(true)
             setdisab(true)
          }
            
        });
      }
    
    })

  return (
    <><Helmet>
    <title>Login</title>
    
</Helmet>
    <div className="container pt-5 pb-5">
        <div className="row">
          <div className="col-12">
      <div className="loginForm">


        <h2 className="mb-5">Login Now .....</h2>

        <form onSubmit={Formik.handleSubmit}>
          <label htmlFor="email">Email :</label>
          <input
            onChange={Formik.handleChange}
            onBlur={Formik.handleBlur}
            type="email"
            name="email"
            id="email"
            placeholder="Enter Your Email"
            className="form-control mt-2 w-75 mb-4 shadow-none"
            value={Formik.values.email}
          />
          {Formik.errors.email && Formik.touched.email ? (
            <div className="alert alert-danger w-75">{Formik.errors.email}</div>
          ) : (
            ""
          )}

          <label htmlFor="password">Password :</label>
          <div className="passwordField">
            <input
              onChange={Formik.handleChange}
              onBlur={Formik.handleBlur}
              type="password"
              name="password"
              id="password"
              placeholder="Enter Your password"
              className="form-control mt-2 w-75 mb-4 shadow-none"
              value={Formik.values.password}
            />{" "}
            <span className="eye1">
              <i
                className="fa-solid fa-eye-slash eyeicon fa-xl cursor-pointer"
                onClick={tranferPass}
              ></i>
            </span>
          </div>
          {Formik.errors.password && Formik.touched.password ? (
            <div className="alert alert-danger w-75">
              {Formik.errors.password}
            </div>
          ) : (
            ""
          )}
           
         <div> <Link  className="text-info fs-5" to='/forgetPassword'>Forget Password ?</Link></div>
          <button
            type="submit"
            className="btn bg-main px-5 py-2 mt-3 text-white"
            disabled={!(Formik.isValid && Formik.dirty && disab)}
          >
            {loading ? (
              <span>Login in</span>
            ) : (
              <span
                className="spinner-grow text-white "
                role="status"
                width={10}
              ></span>
            )}
          </button>
        </form>
      </div></div></div></div>
    </>
  );
}
